<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="name"
      option-value="id"
      :emit-value="true"
      map-options
      hint=""
      :use-chips="multiple"
      :multiple="multiple"
      :loading="applicationsLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        default: null,
      },
      label: {
        type: String,
        default: "Assign Application",
      },
      multiple: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        applications: "applications/list",
        applicationsLoading: "applications/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      applications: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(JSON.stringify(this.applications));
        let idList = null;
        if (this.multiple && this.id) {
          idList = this.id.split(",").map(function (x) {
            return parseInt(x, 10);
          });
        } else {
          idList = this.id;
        }
        this.model = idList;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(JSON.stringify(this.applications));
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.applications.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
    },
  };
</script>
